import { useEffect } from 'react';
import { scrollToTop } from '../../../../utilFunctions';
import UserInfo from './UserInfo';
import MemberDetails from './MemberDetails';
import ClaimHistory from './ClaimHistory';
import PolicyDetails from './PolicyDetails';

const PolicyInfoPage = ({setShowPolicyDetails, setShowClaimForm, policyDetails, setLoading}) => {

    useEffect(()=> {
        scrollToTop()
    },[])
  return (
    <div className="dashboard">
      <UserInfo setShowPolicyDetails={setShowPolicyDetails} setShowClaimForm={setShowClaimForm} policyData={policyDetails}/>
      <PolicyDetails policyData={policyDetails}/>
      <MemberDetails policyData={policyDetails}/>
      <ClaimHistory policyId={policyDetails?.policy_no} setLoading = {setLoading}/>
    </div>
  );
};

export default PolicyInfoPage;